"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var Grid_1 = __importDefault(require("@mui/material/Grid"));
var lodash_1 = require("lodash");
var react_1 = require("react");
var makeTileLayoutStyling_1 = __importDefault(require("./makeTileLayoutStyling"));
var TileLayout = function (_a) {
    var children = _a.children;
    var styles = (0, makeTileLayoutStyling_1.default)({ tileCount: react_1.Children.count(children) });
    var renderTile = function (child, index) { return ((0, jsx_runtime_1.jsx)(Grid_1.default, { item: true, "data-testid": "grid-".concat(index), children: (0, jsx_runtime_1.jsx)("div", { css: styles.tileContainer, children: child }) }, index)); };
    return ((0, jsx_runtime_1.jsx)(Grid_1.default, { css: styles.root, container: true, justifyContent: "center", spacing: 1, "data-testid": "tile-layout-container", children: (0, lodash_1.map)(children, renderTile) }));
};
exports.default = TileLayout;
//# sourceMappingURL=TileLayout.js.map